/* import __COLOCATED_TEMPLATE__ from './figures-subpanel.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type Results from 'filter-wizard/models/results/results';

interface FiguresSubmodelArgs {
  model: ResultsModel;
  errors: string[];
  choice: { source: string };
}
type ResultsModel = { [key: string]: Results | string[]; errors: string[] };

export default class FiguresSubmodel extends Component<FiguresSubmodelArgs> {
  @tracked figureWidth = 500;
  @tracked figureHeight = 300;
  @tracked displayFigureElement: { getBoundingClientRect: () => { [key: string]: number } } | null = null;

  get hasErrors(): boolean {
    const errors = this.args.errors;
    const modelErrors = this.args.model.errors;
    return (errors && errors.length > 0) || (modelErrors && modelErrors.length > 0);
  }

  get figureModel(): ResultsModel | Results {
    const source = this.args.choice.source;
    if (source && this.args.model[source]) {
      return this.args.model[source] as Results;
    } else {
      return this.args.model;
    }
  }
  get displayFigureWidth(): number {
    return this.figureWidth - 20;
  }
  get displayFigureHeight(): number {
    return this.figureHeight - 20;
  }

  @action resizeListener(/*event*/): void {
    if (this.displayFigureElement) {
      const rect = this.displayFigureElement.getBoundingClientRect();
      if (rect['width'] && rect['height']) {
        this.figureWidth = rect['width'];
        this.figureHeight = rect['height'];
      }
    }
  }

  @action insertedDisplayFigure(element: { getBoundingClientRect: () => { [key: string]: number } }): void {
    if (element) {
      this.displayFigureElement = element;
      this.resizeListener();
      window.addEventListener('resize', this.resizeListener);
    }
  }

  @action destroyingDisplayFigure(): void {
    window.removeEventListener('resize', this.resizeListener);
    this.displayFigureElement = null;
  }
}
